import { useState } from "react";
import { Link } from "react-router-dom";
import DashboardPanels from "@/components/DashboardPanels";
import { ChevronLeft, ChevronRight } from "lucide-react";

const iso = (d) => d.toISOString().slice(0, 10);
const todayWIB = () => {
  const n = new Date();
  return iso(new Date(n.getTime() + (7 * 60 + n.getTimezoneOffset()) * 60000));
};
const shift = (dstr, days) => { const d = new Date(dstr); d.setDate(d.getDate() + days); return iso(d); };

const Toggle = () => (
  <div className="mr-1 flex rounded-lg border border-[#29466D] bg-[#102544] p-0.5 text-[11px] font-semibold">
    <Link data-testid="tab-owner" to="/" className="rounded-md px-2.5 py-1 text-[#C3D0E2] hover:text-white">Owner</Link>
    <Link data-testid="tab-harian" to="/dashboard-harian" className="rounded-md bg-[#1684FF] px-2.5 py-1 text-white">Harian</Link>
  </div>
);

export default function DashboardHarian() {
  const [d, setD] = useState(todayWIB());
  const label = new Date(d).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  const picker = (
    <div className="flex flex-wrap items-center gap-1.5">
      <Toggle />
      <button data-testid="harian-prev" onClick={() => setD(shift(d, -1))} className="flex h-8 w-8 items-center justify-center rounded-lg border border-[#29466D] bg-[#102544] text-[#C3D0E2] hover:text-white"><ChevronLeft size={15} /></button>
      <button data-testid="harian-today" onClick={() => setD(todayWIB())} className="h-8 rounded-lg border border-[#29466D] bg-[#102544] px-2.5 text-[11px] font-semibold text-[#C3D0E2] hover:text-white">Hari Ini</button>
      <button data-testid="harian-next" onClick={() => setD(shift(d, 1))} className="flex h-8 w-8 items-center justify-center rounded-lg border border-[#29466D] bg-[#102544] text-[#C3D0E2] hover:text-white"><ChevronRight size={15} /></button>
      <input data-testid="harian-date" type="date" value={d} onChange={(e) => e.target.value && setD(e.target.value)} className="h-8 rounded-lg border border-[#29466D] bg-[#102544] px-2 text-[11px] text-white [color-scheme:dark]" />
    </div>
  );

  return (
    <DashboardPanels
      title="DASHBOARD HARIAN"
      subtitle={`${label} • aktivitas pada tanggal terpilih (WIB)`}
      range={{ from: d, to: d }}
      headerRight={picker}
    />
  );
}
